"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagIB = function FlagIB(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193-92.18H216.6v-22.76a7.06,7.06,0,0,0-7.06-7.06H-185.94a7.06,7.06,0,0,0-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "30.82",
    width: "409.6",
    height: "29.82",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "60.64",
    width: "409.6",
    height: "29.82",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "29.81",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "120.27",
    width: "409.6",
    height: "29.82",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94,146.36H209.54a7.06,7.06,0,0,0,7.06-7.06V116.54H-193V139.3a7.06,7.06,0,0,0,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "150.09",
    width: "409.6",
    height: "29.81",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "179.91",
    width: "409.6",
    height: "29.82",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "209.72",
    width: "409.6",
    height: "29.82",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74,12.18H-185.94A7.06,7.06,0,0,1-193,5.12V-114.94a7.06,7.06,0,0,1,7.06-7.06H4.74a7.06,7.06,0,0,1,7.06,7.06V5.12a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#64466e"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-4.65-62.53H-20.91V-81.11h2.32v-4.65H-41.82v4.65h2.33v18.58h-9.3V-81.11h2.32v-4.65H-69.7v4.65h2.33v18.58H-81.31V-85.76H-79v-4.65h-23.23v4.65h2.31v23.23h-13.93V-81.11h2.32v-4.65h-23.23v4.65h2.33v18.58h-9.3V-81.11h2.33v-4.65h-23.23v4.65h2.32v18.58h-18.59v4.65h2.33v41.81H-144V-30a4.65,4.65,0,0,1,4.65-4.64A4.64,4.64,0,0,1-134.74-30v13.94h23.23V-30a4.65,4.65,0,0,1,4.65-4.64A4.65,4.65,0,0,1-102.21-30v13.94h4.64V-32.33a7,7,0,0,1,7-7,7,7,0,0,1,7,7v16.26H-79V-30a4.64,4.64,0,0,1,4.64-4.64A4.65,4.65,0,0,1-69.69-30v13.94h23.22V-30a4.65,4.65,0,0,1,4.65-4.64A4.65,4.65,0,0,1-37.17-30v13.94H-4.65V-57.88h2.32v-4.65ZM-146.36-43.95h-9.28V-57.88A4.64,4.64,0,0,1-151-62.53a4.64,4.64,0,0,1,4.64,4.65v13.93Zm27.88,0h-9.29V-57.88a4.65,4.65,0,0,1,4.64-4.65,4.65,4.65,0,0,1,4.65,4.65Zm32.53-13.93h-9.3v-9.3a4.65,4.65,0,0,1,4.65-4.64A4.64,4.64,0,0,1-86-67.18Zm32.52,13.93h-9.29V-57.88a4.64,4.64,0,0,1,4.64-4.65,4.65,4.65,0,0,1,4.65,4.65Zm27.87,0h-9.29V-57.88a4.65,4.65,0,0,1,4.65-4.65,4.65,4.65,0,0,1,4.64,4.65Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagIB;
exports["default"] = _default;